// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import { sync } from 'vuex-router-sync';
import iView from 'iview/src';
import axios from 'axios';
import VueAxios from 'vue-axios';
import moment from 'moment';
import App from './App';
import router from './router';
import store from './store';
import locale from './locale/es-ES';
import './theme/index.less';

require('moment/locale/es');
require('moment-timezone');

Vue.use(iView, { locale });
sync(store, router);
axios.defaults.baseURL = process.env.API_URL;
axios.interceptors.request.use((config) => {
  const now = new Date().getTime();
  const jwt = localStorage.getItem('jwt') ? JSON.parse(localStorage.getItem('jwt')) : [];
  if (jwt.length >= 1 && Object.prototype.hasOwnProperty.call(jwt[1], 'token') && Number(jwt[1].expires) > now) {
    config.headers.Authorization = `Bearer ${jwt[1].token}`;
    config.headers.access_token = `${jwt[1].token}`;
  }
  return config;
});
Vue.use(VueAxios, axios);

Vue.config.productionTip = false;
iView.LoadingBar.config({
  height: 5,
});

router.beforeEach((to, from, next) => {
  iView.LoadingBar.start();
  if (to.matched.some(record => record.meta.requiresAuth)) {
    setTimeout(() => {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }, 0);
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.dispatch('isLoggedIn')) {
      next({
        path: '/login',
        query: { redirect: to.fullPath },
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

router.afterEach((transition) => {
  iView.LoadingBar.finish();
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js